import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { LoginButton } from "./LoginButton";
import { LogoutButton } from "./LogoutButton";
import { InteractionStatus } from "@azure/msal-browser";

const LoginLogoutButtons = () => {
    const { inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    if (isAuthenticated) {
        return <LogoutButton />;
    } else if (inProgress !== InteractionStatus.Startup && inProgress !== InteractionStatus.HandleRedirect) {
        // inProgress check prevents sign-in button from being displayed briefly after returning from a redirect sign-in. Processing the server response takes a render cycle or two
        return <LoginButton />;
    } else {
        return null;
    }
}

export default LoginLogoutButtons;